import { EntityType } from '@frontend/common';
import { deceasedRequest } from '@frontend/deceased/events';
import { IDeceased } from '@frontend/deceased/types';
import { CommonMessage } from '@frontend/lang';
import React from 'react';

import { ReactiveDetailRegistryEntry } from '../../modal/reactive-detail-shell/reactive-detail.types';
import { DeceasedDetailsCard, DeceasedEventsSection, DeceasedRelatedTransactionsSection } from './deceased-detail-sections';

export const deceasedReactiveDetail: ReactiveDetailRegistryEntry<IDeceased> = {
    entityType: EntityType.DECEASED,
    resolveFunction: deceasedRequest,
    modalClassName: 'w-full lg:w-2/3 max-w-[900px]',
    title: ({ object }) => (
        <>
            {CommonMessage.OBJECTS.DECEASED.DEFAULT}: {object.name}
        </>
    ),
    tabs: [
        {
            id: 'general',
            label: CommonMessage.DETAIL.GENERAL,
            render: ({ object }) => (
                <>
                    <DeceasedDetailsCard deceased={object} />
                    <DeceasedRelatedTransactionsSection deceased={object} />
                </>
            )
        },
        {
            id: 'events',
            label: CommonMessage.DETAIL.EVENTS,
            render: ({ object }) => <DeceasedEventsSection deceased={object} />
        }
    ]
};
